import React, { Component } from 'react';
import { connect } from 'react-redux';
import cx from 'classnames';
import * as BookerActions from '../../../redux/actions/booking/booker-action-creators';
import storage from '../../utilities/storage-manager';
import AutocompleteDestination from './autocomplate/autocomplate-destination';
import AutocompleteOrigin from './autocomplate/autocomplate-origin';
import TranslatedCopy from '../../intl/translated-copy';


const mapStateToProps = state => ({
  airportsList: state.Booker.airportsList,
  booker: state.Booker,
  originAirport: state.Booker.originAirport,
  tripType: state.Booker.tripType,
});
class FlightBookerRouteSelectorFull extends Component {
  constructor() {
    super();
    this.state = {
      airportsListCMS: [],
      isActiveOrigin: false,
      isActiveDestination: false,
    };
  }

  componentWillMount() {
    const airportsList = storage.get('airportsLiteCMS');

    if (airportsList && airportsList.airports) {
      this.setState({ airportsListCMS: airportsList.airports });
    } else if (airportsList) {
      this.setState({ airportsListCMS: airportsList });
    }
  }

  componentDidMount() {
    const { dispatch } = this.props;
    const { airportsListCMS } = this.state;
    if (airportsListCMS) {
      const airportsList = airportsListCMS;
      const newAirportsList = [];

      airportsList.forEach( item => {
        if (item.airport && item.airport.code && item.airport.code === 'MEX') {
          dispatch(BookerActions.changeOriginAirport(item.airport));
        }

        newAirportsList.push(item.airport);
      });

      const newAirportsListFilter = newAirportsList.filter(item => item.code !== 'MEX');

      dispatch(BookerActions.changeAirportsList(newAirportsList));
      dispatch(BookerActions.changeAirportsListFiltered(newAirportsListFilter));
    }
  }

  render() {
    const { airportsList, tripType, dispatch } = this.props;
    const { isActiveOrigin, isActiveDestination } = this.state;

    const quickBookerRouteWrapper = cx({
      'FlightBookerRouteSelector' : true,
      'FlightBookerRouteQuickBookerWrapper' : true,
      'FlightBookerRouteBookerMainWrapper' : true,
    });

    const quickBookerOriginRouteClasses = cx({
      'FlightBookerRouteQuickbooker' : true,
      'FlightBookerRouteItem-active' : isActiveOrigin,
    });

    const quickBookerDestinationRouteClasses = cx({
      'FlightBookerRouteQuickbooker' : true,
      'FlightBookerRouteItem-active' : isActiveDestination,
    });

    const changeOriginDestinationIcon = cx ({
      'Icon Icon--booker-arrows' : tripType === 'ROUND_TRIP',
      'Icon Icon--booker-arrow' : tripType === 'ONE_WAY',
    });

    return (
      <div>
        <div className={ quickBookerRouteWrapper }>
          <div className={ quickBookerOriginRouteClasses }>
            <div className='FlightBookerRouteSelector-label'>
              <TranslatedCopy copyID='APP_ORIGIN' spaceAfter={ true } />
            </div>
            <div className='FlightBookerRouteSelector-originWrapper'>
              <AutocompleteOrigin 
                airports = { airportsList }
                changeLabelOrigin = { () => this.changeLabelOrigin() }
                dispatch = { dispatch }
                name = 'origin'
                placeholderCopyID='APP_ORIGIN'
                resultItem = { true }
                title = 'APP_ORIGIN'
              />
            </div>
          </div>
          <div className='FlightBookerRouteSelector-icon-container'>
            <span className={ changeOriginDestinationIcon } />
          </div>
          <div className={ quickBookerDestinationRouteClasses }>
            <div className='FlightBookerRouteSelector-label'>
              <TranslatedCopy copyID='APP_DESTINATION' spaceAfter={ true } />
            </div>
            <div className='FlightBookerRouteSelector-originWrapper'>
              <AutocompleteDestination 
                changeLabelDestination = { () => this.changeLabelDestination() }
                dispatch = { dispatch }
                name = 'origin'
                placeholderCopyID='MENU_RESERVA_DESTINATION'
                title = 'APP_DESTINATION'
              />
            </div>
          </div>
        </div>
      </div>
    );
  }

  changeLabelOrigin = () => {
    this.setState({ isActiveOrigin: !this.state.isActiveOrigin });
  }

  changeLabelDestination = () => {
    this.setState({ isActiveDestination: !this.state.isActiveDestination });
  }
}

FlightBookerRouteSelectorFull = connect(mapStateToProps)(FlightBookerRouteSelectorFull);

export default FlightBookerRouteSelectorFull;